<template>
  <div class="page-container base-batch-list">
    <div class="page-title-container">
      <h1 class="page-title">Puntos de venta</h1>
    </div>

    <div class="table-container">
      <div class="table-header">
        <div
          class="d-flex flex-column flex-md-row justify-content-between align-items-start position-relative"
        >
          <div class="w-full w-md-auto md-flex-1">
            <div
              class="d-flex justify-content-between align-items-center justify-content-lg-start"
            >
              <button
                type="button"
                class="filter d-flex align-items-center justify-content-between border-0"
                @click="showFilters = !showFilters"
              >
                <i class="ri-filter-3-line text-dark font-weight-bold"></i>
                <div>Filtrar</div>
              </button>

              <div class="d-flex d-md-none">
                <button
                  type="button"
                  class="button-tooltip text-dark font-weight-bold m-0"
                  v-b-tooltip.hover
                  title="Recargar"
                  @click="loadData()"
                >
                  <i class="ri-loop-right-line"></i>
                </button>

                <button
                  type="button"
                  class="button-tooltip text-dark font-weight-bold"
                  v-b-tooltip.hover
                  title="Descargar"
                  @click="downloadReport()"
                >
                  <i class="ri-download-2-line"></i>
                </button>
              </div>
            </div>
          </div>

          <section
            class="w-full w-md-auto md-flex-1 d-flex justify-content-end align-items-center mt-2 mt-md-0"
          >
            <div class="d-none d-md-flex">
              <button
                type="button"
                class="button-tooltip text-dark font-weight-bold"
                v-b-tooltip.hover
                title="Recargar"
                @click="loadData()"
              >
                <i class="ri-loop-right-line"></i>
              </button>

              <button
                  type="button"
                  class="button-tooltip text-dark font-weight-bold ml-0"
                  v-b-tooltip.hover
                  title="Descargar"
                  v-if="$can('manage', 'pdv_lista_descarga')"
                  @click="downloadReport()"
                >
                  <i class="ri-download-2-line"></i>
                </button>
            </div>

            <div class="w-full w-md-auto d-flex flex-column flex-md-row">
              <SearchBar
                placeholder="Buscar por nombre, documento, zonal o vendedor"
                @search="onSearch"
                @input="search = $event"
                class="flex-1"
              />

              <div class="text-right mt-2 mt-md-0">
                <b-button
                  :to="{ name: 'celulares-sales-points-create' }"
                  variant="none"
                  v-if="$can('manage', 'pdv_lista_agregar')"
                  class="button button-primary ml-md-2"
                  >Agregar</b-button
                >
              </div>
            </div>
          </section>

          <filter-menu
            :show="showFilters"
            @hide="showFilters = false"
            :options="filterOptions"
            :selectedOptionFilter="filters"
            @setFilters="setFilters"
          ></filter-menu>
        </div>

        <div
          class="w-100 d-flex flex-wrap align-items-center mt-2"
          v-if="showFiltersList"
        >
          <span
            v-for="(val, name) in filterList"
            v-bind:key="name"
            class="filter-item"
          >
            {{ getFilterName(name, val) }}
            <button
              type="button"
              class="text-white p-0 bg-transparent border-0 ml-2"
              @click="deleteFilter(name)"
            >
              <i class="ri-close-circle-line"></i>
            </button>
          </span>
        </div>
      </div>

      <div class="mb-0">
        <!-- Mobile -->
        <div class="custom-table-mobile d-xl-none">
          <section class="custom-table-mobile-header">
            <div>
              <span>Número de documento</span>
            </div>

            <div>
              <span>Nombres y Apellidos</span>
            </div>
          </section>

          <div class="custom-table-mobile-body">
            <div class="custom-table-mobile-row" v-for="o in list" :key="o.id">
              <div class="custom-table-mobile-grid">
                <div>
                  <span>{{ o.documentNumber }}</span>
                </div>
                <div>
                  <span>{{ o.names }}</span>
                </div>
                <div>
                  <button
                    type="button"
                    class="border-0 bg-transparent"
                    @click="o.showMobileData = !o.showMobileData"
                  >
                    <span v-if="!o.showMobileData">
                      <i class="ri-arrow-down-s-line"></i>
                    </span>
                    <span v-else>
                      <i class="ri-arrow-up-s-line"></i>
                    </span>
                  </button>
                </div>
              </div>

              <div class="custom-table-mobile-options mt-3">
                <router-link
                  :to="{
                    name: 'celulares-sales-points-edit',
                    params: { id: o.id },
                  }"
                  class="mr-2"
                  v-if="$can('manage', 'pdv_lista_editar')"
                  >Editar</router-link
                >

                <a href="" @click.prevent="openChangeStatus(o)" class="mr-2"
                   v-if="$can('manage', 'pdv_lista_activar')"
                  >{{ getStatus(o.estado).action }}</a
                >
              </div>

              <div class="pt-3" v-if="o.showMobileData">
                <ul class="list-unstyled p-0">
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Tipo:</span
                    >
                    <span>{{ o.typePdv }}</span>
                  </li>
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Zonal:</span
                    >
                    <span>{{ o.zonal ? o.zonal.description : "-" }}</span>
                  </li>
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Clúster:</span
                    >
                    <span>{{ o.cluster || "-" }}</span>
                  </li>
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Vendedor:</span
                    >
                    <span>{{ o.vendedor || "-" }}</span>
                  </li>
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Código ERP:</span
                    >
                    <span>{{ o.codigoERP || "-" }}</span>
                  </li>
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Estado:</span
                    >
                    <span :class="`badge ${getStatus(o.estado).color}`">{{
                      getStatus(o.estado).label
                    }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Desktop -->
        <table class="custom-table w-100 d-none d-xl-table">
          <thead>
            <tr>
              <th>Número de <br> documento</th>
               <th>Nombres y Apellidos</th>
              <th>Tipo</th>
              <th>Zonal</th>
              <th>Clúster</th>
              <th>Vendedor</th>
              <th>Código ERP</th>
              <th>Estado</th>
              <th class="pr-md-3"
                  v-if="$can('manage', 'pdv_lista_activar') ||
                        $can('manage', 'pdv_lista_editar')">Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="o in list" :key="o.id">
              <td class="cell-center">{{ o.documentNumber }}</td>
              <td class="px-3">{{ o.names || "" }} {{ o.surname || "" }}</td>
              <td class="cell-center">{{ o.type ? o.type.description : '-' }}</td>
              <td class="cell-center">
                {{ o.zonal ? o.zonal.description : "-" }}
              </td>
              <td class="cell-center">{{ o.cluster ? o.cluster.description : '-' }}</td>
              <td class="cell-center">{{ o.vendedor || "-" }}</td>
              <td class="cell-center">{{ o.codigoERP || "-" }}</td>
              <td class="cell-center">
                <span :class="`badge ${getStatus(o.estado).color}`">{{
                  getStatus(o.estado).label
                }}</span>
              </td>
              <td class="cell-center d_option pr-md-2 position-relative"
                  v-if="$can('manage', 'pdv_lista_activar') ||
                        $can('manage', 'pdv_lista_editar')">
                <DropdownTable>
                  <template v-slot:dropdown-content>
                    <DropdownItem
                      text="Editar"
                      v-if="$can('manage', 'pdv_lista_editar')"
                      :to="{
                        name: 'celulares-sales-points-edit',
                        params: { id: o.id },
                      }"
                    />

                    <DropdownItem
                      v-if="$can('manage', 'pdv_lista_activar')"
                      :text="getStatus(o.estado).action"
                      @click="openChangeStatus(o)"
                    />
                  </template>
                </DropdownTable>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-footer d-flex justify-content-end align-items-center">
        <pagination
          :total="total"
          :page="page"
          :page-size="pageSize"
          :pages="pages"
          :changePage="changePage"
          :changePageSize="changePageSize"
          v-if="list.length"
        />

        <div class="table-no-results" v-else>
          <p class="m-0 px-3">
            No se encontraron puntos de venta que coincidan con los criterios
            seleccionados.
          </p>
        </div>
      </div>
    </div>

    <ConfirmationModal
      :show="confirmationModal.show"
      @hide="closeConfirmationModal"
      :data="confirmationModal"
      @confirm="confirmModal"
    />
  </div>
</template>

<script>
import { SalesPointService } from "../../Core/Services";
import geoDataMixin from '@/core/Mixins/geoDataMixin'

import {
  Alert,
  Constants,
  DropdownItem,
  DropdownTable,
  FilterMenu,
  FilterMixin,
  PaginationMixin,
  SearchBar,
  Util,
  ConfirmationModal,
  ConfirmationModalMixin
} from "wize-admin";

import { Constants as LocalConstants } from "@/core/utils";

import fileDownload from "js-file-download"

export default {
  mixins: [FilterMixin, PaginationMixin, ConfirmationModalMixin, geoDataMixin],
  components: {
    SearchBar,
    DropdownTable,
    DropdownItem,
    FilterMenu,
    ConfirmationModal
  },
  data() {
    return {
      list: [],
      tooltipType: null,
      pageSize: 100,
      zonalList: [],
      clusterList: [],
      typeList: [],
      filterOptions: [
        {
          label: "Zonal",
          key: "zonalId",
          type: Constants.TypeFilters.SINGLE,
          options: [],
        },
        {
          label: "Tipo",
          key: "typeId",
          type: Constants.TypeFilters.SINGLE,
          options: [],
        },
        {
          label: "Cluster",
          key: "clusterId",
          type: Constants.TypeFilters.SINGLE,
          options: [],
        },
      ],
    };
  },
  methods: {
    async loadData() {
      try {
        const params = {
          page: this.page - 1,
          size: this.pageSize,
          sort: "id",
        };

        const data = { search: this.search, ...this.filters };
        const response = await SalesPointService.list(data, params);

        this.list = response.payload.content.map((item) => {
          return {
            ...item,
            showMobileData: false,
          };
        });

        this.total = response.payload.totalElements;
        this.pages = response.payload.totalPages;
      } catch (e) {
        console.error(e);
        Alert.error(e.errors.message);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    getStatus(key) {
      return Util.searchValue(key, LocalConstants.PdvStatus);
    },
    openChangeStatus(o) {
      this.selectedOption = o;
      this.openConfirmationModal({
        title: "Cambiar estado",
        description: "¿Está seguro que desea cambiar el estado?",
        acceptText: "Aceptar",
        action: "update",
      });
    },
    confirmModal() {
      this.closeConfirmationModal();
      if (this.confirmationModal.action === "update") this.changeStatus();
    },
    async changeStatus() {
      try {
        await this.$store.dispatch("app/loading", true);

        let status = this.selectedOption.estado;

        if (status === LocalConstants.PdvStatus.ACTIVE.key) {
          status = LocalConstants.PdvStatus.INACTIVE.key;
        } else if (status === LocalConstants.PdvStatus.INACTIVE.key) {
          status = LocalConstants.PdvStatus.ACTIVE.key;
        }

        await SalesPointService.changeStatus(this.selectedOption.id, status);
        await this.loadData();
        Alert.success("Estado actualizado correctamente");
      } catch (ex) {
        console.error(ex);
        Alert.error(ex.errors.message);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    async downloadReport() {
      try {
        await this.$store.dispatch("app/loading", true);
        const data = { search: this.search, ...this.filters };
        const response = await SalesPointService.download(data);
        fileDownload(response.data, Util.getFileName(response));
      } catch (error) {
        Alert.error(error);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    }
  },
  async created() {
    await this.$store.dispatch("app/loading", true);
    await this.getZonalList();
    await this.getClusterList();
    await this.getTypeList(LocalConstants.SegmentType.PDV.key);
    await this.loadData();
    await this.$store.dispatch("app/loading", false);
    let zonalFilterOption = this.filterOptions.find(item => item.key === 'clusterId')
    zonalFilterOption.options = this.clusterList;
    const zonalOptions = this.filterOptions.find((o) => o.key === "zonalId");
    zonalOptions.options = this.zonalList;
    const typeOptions = this.filterOptions.find((o) => o.key === "typeId");
    typeOptions.options = this.typeList;
  },
};
</script>

<style lang="stylus" scoped></style>
